import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, Table} from 'reactstrap';
import SyntaxHighlighter from 'react-syntax-highlighter/prism';
import { prism } from 'react-syntax-highlighter/styles/prism';

//style
import '../../../css/codereview.css';

class CodeReview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.showModal
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.showModal
        });
    }

    toggleModal() {
        if(this.state.isOpen) {
            //notify parent that modal is closed
            this.props.closeModalHandler();
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }

    renderComments(comments) {
        if(comments === null || comments.length === 0) {
            return (
                <tr> <td colSpan={2}> Nema komentara koji se odnose na konkretne linije koda.</td> </tr>
            );
        }
        else
        {
            var htmlComments = comments.map((r) => {
                return (
                    <tr>
                        <th> {r.lines} </th>
                        <td> {r.comment} </td>
                    </tr>
                );
            });
            return htmlComments;
        }
    }

    render() {
        var submission = this.props.submission;
        if(submission === null || submission.codeReview === null)
        {
            return (<div></div>);
        }

        //Lines that should be highlighted
        var lines = [];
        submission.codeReview.comments.forEach((r) => {
            let index =  r.lines.indexOf('-');
            if(index === -1) {
                lines.push(parseInt(r.lines, 10));
            }
            else{
                let vals = r.lines.split('-');
                let start = parseInt(vals[0], 10);
                let end = parseInt(vals[1], 10);
                for(var i=start; i<=end; i++)
                {
                    lines.push(i);
                }
            }
        });

        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggleModal} className="codeReviewModal">
                <ModalHeader toggle={this.toggleModal}>
                    <h4>Pregled komentara na kod </h4>
                </ModalHeader>
                <ModalBody className="codeReviewModalBody">
                    <div className="row">
                        <div className="col-7 codeReviewModalBodyColumn">
                            <h4> Kod </h4>
                            <span> Ovo rešenje je prošlo {submission.score}% test primera.</span>
                            <SyntaxHighlighter
                                language='c'
                                style={prism}
                                wrapLines={true}
                                lineProps={lineNumber => {
                                    if(lines.includes(lineNumber))
                                        return { style: {display: 'block', 'background-color': 'rgba(255, 153, 0, 0.32)' }};
                                    else
                                        return {};
                                }}
                                showLineNumbers={true}
                            >
                                {submission.sourceFile}
                            </SyntaxHighlighter>
                        </div>
                        <div className="col-5 codeReviewModalBodyColumn">
                            <h4>Generalni komentar </h4>
                            <p color="#182f37">
                                {
                                    submission.codeReview.general !== null && submission.codeReview.general !== "" ?
                                    submission.codeReview.general :
                                    "/"
                                }
                            </p>

                            <hr className="cr-hr"/>

                            <h4> Komentari po linijama </h4>
                            <Table size="sm" borderless>
                                <thead>
                                <tr>
                                    <th style={{'width':'10%'}}>Linija</th>
                                    <th style={{'width':'90%'}}>Komentar</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {this.renderComments(submission.codeReview.comments)}
                                </tbody>
                            </Table>

                            <hr className="cr-hr"/>

                            <h4> Pregledao </h4>
                            {submission.reviewerAvatar}

                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default CodeReview;